import isObject from 'lodash/isObject'
import { FormDataEnriched, FormElement, FormRow } from 'src/types'

import { BIND_TYPE, FORM_ELEMENT_TYPE } from '@constants'

export const checkValidElementInLine = (
  fields: FormRow[],
  element: FormElement<FormDataEnriched>
) => {
  const isFieldElement = element.type === FORM_ELEMENT_TYPE.FIELD
  const hasValue = element.data && isObject(element.data) && 'value' in element.data
  const isElement = Object.values(FORM_ELEMENT_TYPE).includes(element.type)
  const isJSField = hasValue && (element.data as FormRow).bindType === BIND_TYPE.JS

  if (isFieldElement && !isJSField) {
    const includeValueInRow = Boolean(
      hasValue && fields.find(({ code }) => code === (element.data as FormRow)?.code)
    )

    return includeValueInRow
  }

  return isElement
}
